import React from "react";

const SvgCheckmarkInCircle = props => <svg width={24} height={24} {...props}><g fill="none" fillRule="evenodd"><circle cx={12} cy={12} r={12} fill="currentColor" /><path fill="#fff" d="M16.3 7l-.8.8-5.4 5.9L8.4 12l-.8-.8L6 12.9l.8.8 2.5 2.5.8.8.8-.9 6.3-6.7.8-.8z" /></g></svg>;

export default "//cdn.scentbird.com/assets/frontbird-site/images/checkmark-in-circle_3e7c08.svg";
export { SvgCheckmarkInCircle as ReactComponent };